import type { FaireProductEntity } from "../../entity_types/product";

export const p_pj7n8ed99y: FaireProductEntity = {
  token: "p_pj7n8ed99y",
  type: "product",
  name: "Novelty Socks - Nighttime Creatures",
  brandToken: "b_37zwj76fpy",
  brandName: "Witchwood Bags",
  imageUrl:
    "https://cdn.faire.com/fastly/878f7bcd85dc8f05010582469eab90e706831b310d23e8bde27b71ef3df1697e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/028eb97d12807761b6c4fe3742db7b07a6c455586134bdda2867d5614c5c762a.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "Super fun, soft, novelty socks to spice up any outfit!\n\n\n\n\nMaterial: Poly-blend, for an extra smooth feel.\n\nSize - Adult, one size fits most .\n\n\n\n\n\nThese socks come with our Witchwood branded hanger.\n\n\n",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:33.606Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
